var Backbone = require('backbone'),
    $ = require('jquery');

//TODO: break out widget options from the original state when have to time rewrite module

/* defaults for nested option obj pageLabelAction
 * only come into play if pageLabelAction is provided and these aren't
 * default use case is to for calling app to launch the viewer from the given page
 * should now have separate settings object for the plugin ... (do when reorganize)
 * doesn't include onClick -- default is undefined
 */

var PG_LBL_ACTION_DEFAULTS = {
    title: function(pgNumber) {
        return 'Launch Page ' + pgNumber + ' in Document Viewer';
    },
    appearAsLink: true
};

var State = Backbone.Model.extend({
    hitSelector: '.hit',
    initialize: function() {
        this.$hits = null;
        //note: attributes already set by this point in BB lifecycle -- quick fix for applying defaults to pageLabelAction (if it exists)
        var pageLabelAction = this.get('pageLabelAction');
        if (pageLabelAction) {
            this.set( 'pageLabelAction',  _.extend({}, PG_LBL_ACTION_DEFAULTS, pageLabelAction) );
        }
    },
    defaults: {

        /* attributes to persist across doc change render requests -- currently, not part of the viewer API/config, only the widget */
        simpleMode: true, //if true (the default)-- only shows fields, doc properties, and doc that have hits
        showHits: true,
        grepMode: false,
        wrapText: true,
        fontEmSize: 1,
        localSearchText: "",
        localGrepMode: false,
        pageLabelAction: null, //note: this is a nested obj (with defaults, above)... see documentation

        // original state attributes ... the above should be in a setting object
        currentPg: 1,
        activeHitNumber: - 1, // start assuming not in set
        _lastHitLine: null,
        _lastHitPage: null,
        lastScrollTop: 0,
        searchInputEnabled: false /* attr changed that fires event when user clicks edit search */
    },
    getArrayOfAttributesToPersist: function() {
        //NOTE: the search text, docId, and url are stored on the ES model -- which is fetched prior to creation/rendering of the module
        return ['showHits', 'grepMode', 'wrapText', 'fontEmSize', 'simpleMode', 'localSearchText', 'localGrepMode', 'pageLabelAction'];
    },
    getAttributesToPersistOnReset: function() {
        return _.pick( this.toJSON(), this.getArrayOfAttributesToPersist() );
    },
    /* set the hits and the active hit index, always triggering a change to scroll back to the active hit, called after page view renders */
    setHits: function($containingEl, options) { /* now not only done once options.initialLoadCallback -- will go to next */

        this.$hits = $containingEl.find(this.hitSelector);

        if (!options.fromGrepToggle && !options.fromSimpleModeToggle) {
            this.navigateHits('Next', options);
            return;
        }

        //hits that did exist may no longer (content swapped)
        //TODO: OK DECIDE & CLEAN ... EG ALL COULD HAVE LIST PG AND HIT LINE, (AND USE THAT FOR NAVIGATION --
        // but would need to either print the hit number of the line in question or derive it in here via jquery)

        if (!this.get('localGrepMode')) {
            //Activate the current -- all hits will be shown in ES GREP/ no GREP at all (if ANY EXIST); force change b/c will be the same hit, so scroll to it
            this.setActiveHit(this.get('activeHitNumber'), options);
            return;
        }

        /* LOCAL GREP MODE */

        //in local grep .... content is always reset
        if (!this.previous('localGrepMode')) {
            //if toggling in from first time, go to the first hit -- only printing data attributes on local grep
            this.setActiveHit( 0, options );

        } else {
            //content change from typing
            var lastHitPg = this.get('_lastHitPage');
            var lastHitLine = this.get('_lastHitLine');

            //TODO: COULD BE MORE THAN 1 (would need to derive the number of the line) -- NOW JUST TAKING THE FIRST as quick fix
            var $lastHit =  this.$hits.filter( function() {
                var data = $(this).data();
                return data.pg === lastHitPg && data.line === lastHitLine;
            }).eq(0);

            this.setActiveHit( this.$hits.index($lastHit), options);

        }

    },
    /* also sets active hit numbers */
    navigateHits: function(action, options) {
        var max = this.$hits.length - 1,
            activeHitNumber = this.get('activeHitNumber'),
            actionHitNum = { 
                Next: function() {
                    return activeHitNumber + 1;
                },
                Previous: function() {
                    return activeHitNumber - 1;
                },
                First: function() {
                    return 0;
                },
                Last: function() {
                    return max;
                }
            },
            hitPosition = actionHitNum[action]();

        /* prevent jq wrapping */
        if (hitPosition === -1 && activeHitNumber === 0) return false;
        if (hitPosition === max + 1 && activeHitNumber === max) return false;

        this.setActiveHit(hitPosition, _.extend( {}, options, {fromNavigation: true}));
    },
    /* mark hit */
    setActiveHit: function(hitPosition, options) {

        //always force change -- WANT THE CALLBACK -- COULD TRIGGER EVENT INSTEAD
        this.set('activeHitNumber', null, {silent: true});

        this.$hits.length > 0 && this.$hits.removeClass('active');

        var $hit = this.$hits.eq(hitPosition);
        $hit && $hit.length > 0 && $hit.addClass('active');

        this.set({
            activeHitNumber: hitPosition,
            _lastHitLine: $hit.data('line'), //TODO: REALLY ONLY WAS DOING FOR LOCAL GREP
            _lastHitPage: $hit.data('pg')
        }, options) ;

    },
    //call when clicking out of es grep
    setActiveHitIndex: function($hit) {
            this.set({
                activeHitNumber: this.$hits.index( $hit )
            },  {silent: true} //todo: always want to scroll to set page?
        );
    },
    changeFontSize: function(how) {
        var fs =  this.get('fontEmSize');
        this.set({fontEmSize: fs + ( (fs * 0.10) * (how === 'larger' ? 1: - 1) ) });
    },
    getActiveHit: function() {
        return this.$hits.eq(this.get('activeHitNumber'));
    },
    /* currently used pre-toggle grep mode */
    activeHitIsFirstOrLast: function() {
        var n = this.get('activeHitNumber');
        return n === 0 || n === this.$hits.length - 1;
    },
    getNumberOfHits: function() {
        return this.$hits.length;
    },
    cleanHits: function() {
        if (this.$hits) {
            this.$hits.remove();
            this.$hits = null;
        }
    },
    destroy: function() {
        this.cleanHits();
        Backbone.Model.prototype.destroy.call(this);
    }
});

module.exports = State;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/fulltext/layout/state.js
 ** module id = 556
 ** module chunks = 0
 **/